import React from "react";
import MoneyValue from "../../components/MoneyValue/MoneyValue";
import { getDisplayDateWithoutWholeYear } from "../../utils/functions";
import FilterAllocation from "../../components/FilterAllocation/FilterAllocation";
import { allocationColorsStatic } from "../../utils/constants";
import infoIcon2 from "../../assets/images/svg/infoIcon2.svg";

const SubAssetTilesData = ({
  currentInvestmentReturns,
  selectedInstrument,
}) => {
  return (
    <div className="money_values_first">
      <MoneyValue
        title="Current Value"
        hasWidth={true}
        amount={`${currentInvestmentReturns?.current_value?.value || "-"}`}
        unitType={currentInvestmentReturns?.current_value?.value_type || ""}
        date1={
          currentInvestmentReturns?.as_of_date
            ? "As on " +
              getDisplayDateWithoutWholeYear(
                currentInvestmentReturns?.as_of_date
              )
            : "-"
        }
      />

      <MoneyValue
        title="Invested Value"
        hasWidth={true}
        amount={`${currentInvestmentReturns?.invested_value?.value || "-"}`}
        unitType={currentInvestmentReturns?.invested_value?.value_type || ""}
      />

      <MoneyValue
        hasWidth={true}
        title="Int/Div"
        amount={`${currentInvestmentReturns?.int_div?.amount?.value || "-"} `}
        unitType={currentInvestmentReturns?.int_div?.amount?.value_type || ""}
      />

      <MoneyValue
        hasWidth={true}
        title="Unrealised Gains (%)"
        amount={`${
          currentInvestmentReturns?.unrealised_gain?.amount?.value || "-"
        }`}
        unitType={
          currentInvestmentReturns?.unrealised_gain?.amount?.value_type || ""
        }
        batchAmount={currentInvestmentReturns?.unrealised_gain?.percentage}
      />

      <MoneyValue
        hasWidth={true}
        title="Realised Gain"
        amount={`${
          currentInvestmentReturns?.realised_gain?.amount?.value || "-"
        } `}
        unitType={
          currentInvestmentReturns?.realised_gain?.amount?.value_type || ""
        }
      />

      <MoneyValue
        totalAndIrr={`${
          currentInvestmentReturns?.total_returns?.value || "-"
        } `}
        totalAndUnit={currentInvestmentReturns?.total_returns?.value_type || ""}
        title="Total Returns (IRR)"
        infoLogo={infoIcon2}
        amount={`${currentInvestmentReturns?.irr || "-"}${
          !!currentInvestmentReturns?.irr ? "%" : ""
        }`}
        hasWidth={true}
        TooltipContent={
          <div className="irr_tip tip_align">
            <h2>Total Returns</h2>
            <p>(Realised + Unrealised + Int/Div and Other Income)</p>
          </div>
        }
        tipClass="subAssetLevel"
        totalReturnSubAsset={true}
      />

      <FilterAllocation
        barcolor={
          allocationColorsStatic[selectedInstrument?.assetClassData?.id]
        }
        title={"Allocation"}
        percentageAmout={
          selectedInstrument?.vehicleData?.allocation_percentage
            ? selectedInstrument?.vehicleData?.allocation_percentage + "%"
            : "-"
        }
      />
    </div>
  );
};

export default SubAssetTilesData;
